import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue'
  import Badge from '@/components/common/Badge.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useDuration from '@/composables/useDuration'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { CourseModule } from '@/store/modules/course'
  import useCourse from '@/composables/useCourse'
  import useBreakpoint from '@/composables/useBreakpoint'
  import type { CourseModule as CourseModuleState } from '@/services/interfaces/Course'
  import CourseModulesLoader from '@/components/loaders/CourseModulesLoader.vue'
  import useShopifyClient from '@/composables/useShopifyClient'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseModules',
  emits: ['fetching-course-modules'],
  setup(__props, { emit }) {

  const { durationIcon, lesson, lockIcon, open } = useIcons()
  const { formatDurationToHHMM } = useDuration()
  const { isDesktopDevice } = useBreakpoint()
  const { convertToRoman } = useCommonMixin()
  const { createShopifyCheckout } = useShopifyClient()
  const { isPurchasedCourse, currentCourseId, courseModules, course, guidedQuizDuration, openLessonModal } = useCourse()

  

  const fetchingCourseModules = computed(() => CourseModule.coursesModuleMap[currentCourseId.value] === undefined)

  const filteredCourseModules = computed(() => {
    if (!course.value?.courseGroups?.length) {
      return {
        '': {
          name: '',
          modules: courseModules.value,
        },
      }
    }
    return course.value.courseGroups.reduce(
      (acc, group) => {
        acc[group.id] = {
          name: group.name,
          modules: courseModules.value?.filter((mod) => mod.courseGroupId === group.id) || [],
        }
        return acc
      },
      {} as { [key: string]: { name: string; modules: CourseModuleState[] } },
    )
  })

  const isLockedModule = computed(() => (isFree: boolean) => {
    return !course.value?.purchased && !isFree && !course.value?.expired
  })

  watch(fetchingCourseModules, (value) => {
    emit('fetching-course-modules', value)
  })

  if (fetchingCourseModules.value) {
    CourseModule.getCourseModules(currentCourseId.value)
  } else {
    emit('fetching-course-modules', false)
  }

  const routeToLessonOrCheckout = (module: CourseModuleState, lessonId: string) => {
    if (isLockedModule.value(module.isFree)) {
      createShopifyCheckout()
      return
    }

    openLessonModal({
      lessonId,
      moduleId: module.id,
    })
  }

  const approximateModuleDuration = (module: CourseModuleState) => {
    const lessonDurations = module.lessons.map((lesson) => lesson.duration || 0)
    const totalLessonDuration = lessonDurations.reduce((total, duration) => total + duration, 0)

    const _guidedQuizDuration = module.guidedQuiz ? guidedQuizDuration.value(module.guidedQuiz.numberOfQuestions) : 0

    const totalDuration = totalLessonDuration + _guidedQuizDuration
    return formatDurationToHHMM(Math.round(totalDuration))
  }

return { __sfc: true,durationIcon, lesson, lockIcon, open, formatDurationToHHMM, isDesktopDevice, convertToRoman, createShopifyCheckout, isPurchasedCourse, currentCourseId, courseModules, course, guidedQuizDuration, openLessonModal, emit, fetchingCourseModules, filteredCourseModules, isLockedModule, routeToLessonOrCheckout, approximateModuleDuration, computed, watch, Badge, SVGRenderer, HTMLRenderer, useIcons, useDuration, useCommonMixin, CourseModule, useCourse, useBreakpoint, CourseModulesLoader, useShopifyClient }
}

})